/**
*
* HTTP Interceptor
* Description: API call passes through this Interceptor
* Created Date: 05/11/2018 
* Created by: Avaya
* Revision History:
* Modification date: 
* Description:
***/
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
 
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
 
import { ErrorHandler } from './errorHandler.service';

 
@Injectable()
export class RequestInterceptor implements HttpInterceptor {
 
  constructor(
    public errorHandler : ErrorHandler,
    // public spinner: NgxSpinnerService
  ) {}
 
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).do((event: HttpEvent<any>) => {}, 
    (err: any) => {
      if (err instanceof HttpErrorResponse) {
        // this.spinner.hide();
        this.errorHandler.handleError(err);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/httpInterceptor.service.ts